export default "__VITE_ASSET__aQSnG1m___"